<template>
  <div class="recruit-box">
    <img
      src="https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/png/ABFWXMNTK0134569_1593684119.png"
      class="recruit-top-img banCopy"
    />

    <div class="recruit-table-box transition">
      <div class="recruit-search-box banCopy">
        <div class="recruit-icon-div">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16"
          >
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
            />
          </svg>
        </div>

        <input
          type="text"
          placeholder="请输入新闻的关键词"
          class="recruit-search-input"
          @keyup.enter="inputPost()"
        />

        <button class="recruit-submit" @click="inputPost()">搜索</button>
      </div>

      <table class="table table-backColor table-hover recruit-table">
        <tbody>
          <tr class="table-title banCopy">
            <td>岗位名称</td>
            <td>任职公司</td>
            <td class="d-none d-lg-block">学历要求</td>
            <td>工作地点</td>
            <td class="d-none d-lg-block">招聘人数</td>
            <td>更新时间</td>
          </tr>

          <tr v-for="item in recruitList" :key="item">
            <td
              :class="{ 'posts-title': tableShow == true }"
              class="hand"
              @click="gotoDetails(item.post_name)"
            >
              {{ item.post_name }}
            </td>
            <td>
              {{ item.serving_company }}
            </td>
            <td
              :class="{
                'd-none': tableShow == true,
                'd-lg-table-cell': tableShow == true,
                education: tableShow == true,
              }"
            >
              <span class="education-span">
                {{ item.education }}
              </span>
            </td>
            <td :class="{ place: tableShow == true }">
              {{ item.place }}
            </td>
            <td
              :class="{
                'd-none': tableShow == true,
                'd-lg-table-cell': tableShow == true,
                'recruit-number': tableShow == true,
              }"
            >
              {{ item.recruit_number }}
            </td>
            <td>
              {{ item.create_time }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pageNumber-box banCopy transition">
        <ul
          class="
            list-unstyled list-group list-group-horizontal list-inline
            pageNumber-list
          "
        >
          <li>
            <button class="prev-but" :disabled="prev" @click="prevFunction()">
              &lt;
            </button>
          </li>
          <li
            v-for="(item, index) in pageNumbar"
            :key="index"
            class="pagerNumber hand"
            :class="{
              active: currentNumber == item,
              changeColor: changeColorBl == item,
            }"
            @click="pagerNumberFun($event)"
            @mousemove="hoverItem($event)"
            @mouseout="hoverOut($event)"
          >
            {{ item }}
          </li>
          <li>
            <button class="next-but" :disabled="next" @click="nextFunction()">
              >
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script scoped>
export default {
  mounted() {
    document.title="杭开集团-人员招聘";

    if (this.storageList.length == 0) {
      this.Post();
    }
  },
  watch: {
    currentNumber() {
      var a = 0;
      this.recruitList = [];
      if (this.currentNumber == this.pageNumbar) {
        var strat = (Number(this.currentNumber) - 1) * Number(this.number);
        var cease = this.storageList.length;
        // console.log(strat + "  " + cease)
        for (var i = strat; i < cease; i++) {
          //console.log(i)
          this.recruitList[a] = this.storageList[i];
          a++;
        }
      } else {
        var strat = (Number(this.currentNumber) - 1) * Number(this.number);
        var cease = Number(this.number) * Number(this.currentNumber);
        //console.log(strat + "  " + cease)
        for (var i = strat; i < cease; i++) {
          this.recruitList[a] = this.storageList[i];
          a++;
        }
      }
    },
  },
  data() {
    return {
      tableShow: true,
      prev: true,
      next: false,
      changeColorBl: 0,
      storageList: [], //存放的内容
      recruitList: [], //显示的内容
      pageNumbar: 1, //总页码
      number: 10, //每页显示12个
      currentNumber: 1, //当前页码
    };
  },
  methods: {
    inputPost() {
      var string = "";
      string = $(".recruit-search-input").val();
      if (string == "") {
        var url = "http://demoapi.hkjt.cn/pages/recruit.php";
      } else {
        var url =
          "http://demoapi.hkjt.cn/pages/recruit.php?type=1&string=" + string;
      }
      this.axios.get(url).then((res) => {
        this.recruitList = [];
        if (res.data.length == 0) {
          this.pageNumbar = 0;
        } else {
          this.storageList = res.data;
        }

        this.pageNumbar = Math.ceil(this.storageList.length / this.number);
        var a = 0;

        if (res.data.length < this.number) {
          for (var i = 0; i < res.data.length; i++) {
            this.recruitList[a] = this.storageList[i];
            a++;
          }
        } else {
          for (var i = 0; i < this.number; i++) {
            this.recruitList[a] = this.storageList[i];
            a++;
          }
        }
        //aconsole.log(this.recruitList)
      });
    },
    Post() {
      var url = "http://demoapi.hkjt.cn/pages/recruit.php";
      this.axios.get(url).then((res) => {
        if (res.data.length == 0) {
          this.pageNumbar = 0;
        } else {
          this.storageList = res.data;
        }

        this.pageNumbar = Math.ceil(this.storageList.length / this.number);

        var a = 0;
        if (res.data.length < this.number) {
          for (var i = 0; i < res.data.length; i++) {
            this.recruitList[a] = this.storageList[i];
            a++;
          }
        } else {
          for (var i = 0; i < this.number; i++) {
            this.recruitList[a] = this.storageList[i];
            a++;
          }
        }
        //console.log(this.storageList)
      });
    },

    prevFunction() {
      var num = this.currentNumber;
      num--;
      if (num == 1) {
        this.currentNumber = 1;
        this.prev = true;
      } else {
        this.currentNumber = num;
      }
      if (num != this.currentNumber) {
        this.next = false;
      }
    },
    nextFunction() {
      var num = this.currentNumber;
      num++;
      if (num == this.pageNumbar) {
        this.currentNumber = this.pageNumbar;
        this.next = true;
      } else {
        this.currentNumber = num;
      }
      if (num != 1) {
        this.prev = false;
      }
    },
    pagerNumberFun(e) {
      var numbar = e.currentTarget.innerHTML;
      this.changeColorBl = 0;
      this.currentNumber = numbar;
    },
    hoverItem(e) {
      var numbar = e.currentTarget.innerHTML;
      if (numbar != this.pageNumbar) {
        this.changeColorBl = numbar;
      }
    },
    hoverOut(e) {
      this.changeColorBl = 0;
    },
    gotoDetails(string) {
      for (var i = 0; i < this.recruitList.length; i++) {
        if (string == this.recruitList[i]["post_name"]) {
          var num = i;
          break;
        }
      }
      this.$router.push({
        name: "recruitDetails",
        query: {
          create_time: this.recruitList[i]["create_time"],
          post_name: this.recruitList[i]["post_name"],
          working_life: this.recruitList[i]["working_life"],
          education: this.recruitList[i]["education"],
          recruit_number: this.recruitList[i]["recruit_number"],
          serving_company: this.recruitList[i]["serving_company"],
          place: this.recruitList[i]["place"],
          job_description: this.recruitList[i]["job_description"],
          job_requirements: this.recruitList[i]["job_requirements"],
        },
      });
    },
  },
};
</script>

<style scoped>
.table-title > td {
  color: #000 !important;
  font-size: 0.9375rem !important;
}

.bi-search {
  color: rgb(192, 196, 204);
}

.recruit-box {
  font-size: 0.9375rem;
}

tr > td {
  /* display: table-cell; */
  vertical-align: middle;
}

tr {
  padding: 0 2rem;
}

.table > :not(caption) > * > * {
  padding: 0 !important;
}

.education {
  display: flex;
  flex-wrap: wrap;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}

.education-span {
  display: block;
  margin: 0 auto;
  max-width: 15rem;
}

.recruit-icon-div {
  margin-left: 1rem;
}

.recruit-search-box {
  border: 1px solid rgb(220, 223, 230);
  width: 50rem;
  height: 2.5rem;
  border-radius: 30rem;
  display: flex;
  align-items: center;
  margin: 5rem auto 2rem auto;
  position: relative;
}

.recruit-search-box:focus-within {
  border: 1px solid #409eff;
}

.recruit-search-input {
  height: 100%;
  border: 0px;
  padding-left: 1rem;
  color: #606266;
  font-size: 0.9375rem;
  width: 82%;
  outline: none;
}

.recruit-search-input:focus {
  border: 0;
}

.recruit-submit {
  background-color: #409eff;
  color: #fff;
  border: 0;
  box-shadow: 0;
  height: 90%;
  width: 5.5rem;
  border-radius: 30rem;
  font-size: 0.9rem;
  line-height: 100%;
  position: absolute;
  right: 0.1rem;
}

.recruit-submit:hover {
  background-color: #40a0ffc2;
}

.posts-title {
  color: #237fef !important;
}

.table-title {
  color: #000 !important;
  font-weight: bold !important;
  word-wrap: break-word;
  word-break: break-all;
  padding: 0 0.5rem;
}

.pageNumber-box {
  width: 75rem;
  margin: 0 auto 5rem auto;
}

.recruit-top-img {
  width: 100%;
  height: 31.67vw;
  object-fit: cover;
}

.table {
  margin-bottom: 2rem !important;
  color: #606266;
}

.table-backColor > tbody > tr:nth-of-type(odd) > * {
  color: #606266;
}

.recruit-table {
  text-align: center;
  width: 75rem;
  margin: 1rem auto 5rem auto;
  line-height: 3rem;
}

.place {
  line-height: 1.8rem;
}

.table-backColor > tbody > tr:nth-child(2n + 1) > td,
.table-backColor > tbody > tr:nth-child(2n + 1) > th {
  background-color: rgb(250, 250, 250) !important;
}

@media screen and (max-width: 1250px) {
  .recruit-table {
    width: 100%;
  }

  .pageNumber-box {
    width: 100%;
    padding-right: 2rem;
  }
}

@media screen and (max-width: 991px) {
  .recruit-search-box {
    width: 95%;
  }
}

@media screen and (max-width: 540px) {
  .table-title > td {
    color: #000 !important;
    font-size: 0.7rem !important;
  }

  tbody > tr > td {
    min-width: 3.125rem;
  }

  .place {
    width: 7.5rem;
  }

  .pageNumber-box > ul {
    width: auto;
    margin: 0 auto;
  }
}
</style>